import React from 'react';
import './Footers.css'

const Footers = () => {
    return (
        <div>
            <div className="container-fluid foots">
            <div className="row">
                <div className="col-lg-12">
                    <div className="footers">
                        <p className='mb-0'>Copyright © 2022 Arctic-Health-Club-apps</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default Footers;